/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

export const ADD_NOTE_TO_ACTION = gql`
  mutation AddNoteToAction($input: AddNoteToActionInput!) {
    addNoteToAction(data: $input) {
      id
      note
    }
  }
`
